import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function HalfCircle(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 10 10">
      <path d="M10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 1.00116e-07 5 0C3.67392 -1.00116e-07 2.40215 0.526784 1.46447 1.46447C0.526785 2.40215 2.00233e-07 3.67392 0 5L5 5H10Z"/>
    </SvgIcon>
  );
}